webpackJsonp([277768745375809],{

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _panel = __webpack_require__(11);
	
	var _panel2 = _interopRequireDefault(_panel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TicketsPage = function TicketsPage() {
	  return _react2.default.createElement(
	    "div",
	    { className: "page" },
	    _react2.default.createElement(
	      "div",
	      { className: "about" },
	      _react2.default.createElement(
	        "section",
	        { className: "col-2" },
	        _react2.default.createElement(
	          _panel2.default,
	          { title: _react2.default.createElement(
	              "h2",
	              null,
	              "Tickets"
	            ), "class": "box benefits" },
	          _react2.default.createElement(
	            "p",
	            null,
	            "Tickets sold for 4500 NOK including MVA. We had three ticket drops. Here is an overview of the ticket drops:"
	          ),
	          _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "s",
	                null,
	                "Tuesday April 24th at 14:00 CEST"
	              ),
	              " (sold out)"
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "s",
	                null,
	                "Friday April 27th at 17:00 CEST"
	              ),
	              " (sold out)"
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "s",
	                null,
	                "Monday May 7th at 17:00 CEST (last batch)"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "\uD83C\uDF9F We were selling our tickets over at Tito.",
	            " ",
	            _react2.default.createElement(
	              "a",
	              { href: "https://ti.to/webrebels/2018" },
	              "Link to tickets"
	            ),
	            "."
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = TicketsPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tickets-js-802f8d4658d7fc0539fc.js